export const getCaptchaDriver = 'arcaptcha'; // or 'recaptcha'
export default getCaptchaDriver;    